import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { LanguageProvider } from "./i18n/LanguageContext";
import { Seo } from "./components/Seo";
import { Navbar } from "./components/Navbar";
import { Footer } from "./components/Footer";
import { WhatsAppButton } from "./components/WhatsAppButton";
import { Home } from "./pages/Home";
import { PrivacyPolicy } from "./pages/PrivacyPolicy";
import { TermsOfService } from "./pages/TermsOfService";
import { DataDeletion } from "./pages/DataDeletion";
export function App() {
  return <LanguageProvider data-id="element-0" data-mp="2mjzplczyq3q9">
      <BrowserRouter data-id="element-1" data-mp="31b8jvzet8d9q">
        <Seo data-id="element-2" data-mp="31brzvakwgrl4" />
        <div className="w-full min-h-screen bg-white" data-id="element-3" data-mp="31c9vq63nh3si">
          <Navbar data-id="element-4" data-mp="2wjgqlh49rtfw" />
          <Routes data-id="element-5" data-mp="2wiyy8vkq9zd9">
            <Route path="/" element={<Home data-id="element-7" data-mp="2whxaprmizken" />} data-id="element-6" data-mp="2wiffjcn976y6" />
            <Route path="/politica-de-privacidad" element={<PrivacyPolicy data-id="element-9" data-mp="28t4jg8gum0qd" />} data-id="element-8" data-mp="28u5x8kp911bs" />
            <Route path="/terminos-de-servicio" element={<TermsOfService data-id="element-11" data-mp="23w4clvc6cty7" />} data-id="element-10" data-mp="28s2xh8yanttv" />
            <Route path="/eliminar-datos" element={<DataDeletion data-id="element-13" data-mp="3ik7g4ghnibqn" />} data-id="element-12" data-mp="23v2rsz5cwt3a" />
            <Route path="*" element={<Navigate to="/" replace data-id="element-15" data-mp="3ijpbowku4r7n" />} data-id="element-14" data-mp="3iiwfgpji5k3r" />
          </Routes>
          <Footer data-id="element-16" data-mp="3mkre1ma1tjdu" />
          <WhatsAppButton data-id="element-17" data-mp="3mk868ye44bdj" />
        </div>
      </BrowserRouter>
    </LanguageProvider>;
}